(() => {
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const initRootTabs = () => {
    document.querySelectorAll('[data-kjg-root-size]').forEach((button) => {
      if (button.dataset.kjrTakeoverInit === 'true') return;
      button.dataset.kjrTakeoverInit = 'true';
      button.addEventListener('click', () => {
        const size = button.getAttribute('data-kjg-root-size');
        document.querySelectorAll('[data-kjg-root-size]').forEach((tab) => {
          tab.classList.toggle('is-active', tab === button);
          tab.setAttribute('aria-pressed', tab === button ? 'true' : 'false');
        });
        document.querySelectorAll('[data-kjg-root-panel]').forEach((panel) => {
          panel.hidden = panel.getAttribute('data-kjg-root-panel') !== size;
        });
        document.querySelectorAll('[data-kjg-root-image]').forEach((image) => {
          image.hidden = image.getAttribute('data-kjg-root-image') !== size;
        });
      });
    });
  };

  const fixCompareLinks = () => {
    document.querySelectorAll('a[href]').forEach((link) => {
      if (normalize(link.textContent).toLowerCase() !== 'compare level models') return;
      link.setAttribute('href', window.location.pathname === '/' ? '#level-comparison' : '/#level-comparison');
    });
  };

  const addSubLabel = (cell, text) => {
    if (!cell || cell.querySelector('.kjr-model-sub')) return;
    const label = document.createElement('span');
    label.className = 'kjr-model-sub';
    label.textContent = text;
    const link = cell.querySelector('a');
    if (link) cell.insertBefore(label, link);
    else cell.appendChild(label);
  };

  const setCell = (row, index, text) => {
    if (!row || !row.cells[index]) return;
    row.cells[index].textContent = text;
  };

  const setCells = (row, valuesByIndex) => {
    if (!row) return;
    Object.entries(valuesByIndex).forEach(([index, text]) => setCell(row, Number(index), text));
  };

  const polishLevelComparison = () => {
    const table = document.querySelector('.kjg-compare-table');
    if (!table) return;

    if (table.dataset.kjrComparisonReordered !== 'true') {
      const order = [0, 1, 2, 3, 4, 5, 6, 8, 7];
      table.querySelectorAll('tr').forEach((row) => {
        const cells = Array.from(row.children);
        if (cells.length >= 9) {
          order.forEach((originalIndex) => {
            if (cells[originalIndex]) row.appendChild(cells[originalIndex]);
          });
        }
      });
      table.dataset.kjrComparisonReordered = 'true';
    }

    const headerCells = table.tHead && table.tHead.rows[0] ? Array.from(table.tHead.rows[0].cells) : [];
    if (headerCells[0]) headerCells[0].textContent = 'Model';
    addSubLabel(headerCells[1], 'Matter over Thread');
    addSubLabel(headerCells[2], 'Matter over Thread');
    addSubLabel(headerCells[3], 'Matter over Thread');

    const bodyRows = Array.from(table.tBodies[0]?.rows || []);
    const rowByHeading = (heading) => bodyRows.find((row) => normalize(row.cells[0]?.textContent).toLowerCase() === heading);

    setCells(rowByHeading('family'), {
      1: 'Current core model',
      2: 'Current core model',
      3: 'Current core model',
      4: '(2023)',
      5: '(2022)',
      6: '(2020)',
      7: '(2020)',
      8: '(2019)'
    });

    setCells(rowByHeading('matter support'), {
      1: 'Yes',
      2: 'Yes',
      3: 'Yes',
      4: 'No',
      5: 'No',
      6: 'No',
      7: 'No',
      8: 'No'
    });

    setCells(rowByHeading('thread support'), {
      1: 'Yes',
      2: 'Yes',
      3: 'Yes',
      4: 'No',
      5: 'No',
      6: 'No',
      7: 'No',
      8: 'No'
    });

    setCells(rowByHeading('apple home / homekit'), {
      1: 'Via compatible Matter setup',
      2: 'Via compatible Matter setup',
      3: 'Via compatible Matter setup'
    });

    setCells(rowByHeading('apple home keys'), {
      1: 'Yes',
      2: 'Yes',
      3: 'No',
      4: 'Yes',
      5: 'Yes',
      6: 'No',
      7: 'No',
      8: 'No'
    });

    setCells(rowByHeading('remote access requirement'), {
      1: 'Compatible Matter-over-Thread hub or Level Connect',
      2: 'Compatible Matter-over-Thread hub or Level Connect',
      3: 'Compatible Matter-over-Thread hub or Level Connect',
      4: 'Level Connect included',
      5: 'Level Connect or compatible home hub',
      6: 'Level Connect or compatible home hub',
      7: 'Level Connect included',
      8: 'Level Connect or compatible home hub'
    });
  };

  const addFeaturedLevelTechLabels = () => {
    document.querySelectorAll('.kjg-product-body h3').forEach((heading) => {
      if (heading.parentElement?.querySelector('.kjr-product-tech')) return;
      const title = normalize(heading.textContent).toLowerCase();
      let text = '';
      if (title === 'level lock pro') text = 'Matter over Thread • Home Key';
      else if (title === 'level lock' || title === 'level bolt') text = 'Matter over Thread';
      if (!text) return;
      const label = document.createElement('span');
      label.className = 'kjr-product-tech';
      label.textContent = text;
      heading.insertAdjacentElement('afterend', label);
    });
  };

  const init = () => {
    initRootTabs();
    fixCompareLinks();
    document.querySelectorAll('.kjr-order-info').forEach((node) => node.remove());
    polishLevelComparison();
    addFeaturedLevelTechLabels();
    requestAnimationFrame(() => {
      polishLevelComparison();
      addFeaturedLevelTechLabels();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
